import React from 'react';
import CertificationCard from '../CeritifcationCard/index.js';

const CertificationsList = ({ certifications }) => {
  if (certifications.length === 0) {
    return (
      <div className="empty-state">
        <p className="text-lg mb-2">No certifications found</p>
        <p className="text-gray-400">Try changing your search filters</p>
      </div>
    );
  }

  return (
    <div className="certifications-grid">
      {certifications.map((certification) => (
        <CertificationCard key={certification.id} certification={certification} />
      ))}
    </div>
  );
};

export default CertificationsList;